import React from 'react';

import {
  AtomDrawerContent,
  CroDrawerContent,
  LatomDrawerContent,
  LcroDrawerContent,
  VnoDrawerContent,
} from '../GetAssetDrawers';
import { useAccountModalStore } from './useAccountModalStore';

function AccountModalDrawerContentsCronos() {
  const openDrawer = useAccountModalStore((s) => s.openDrawer);

  return (
    <>
      {openDrawer === 'cro' && <CroDrawerContent />}
      {openDrawer === 'vno' && <VnoDrawerContent />}
      {openDrawer === 'atom' && <AtomDrawerContent />}
      {openDrawer === 'lcro' && <LcroDrawerContent />}
      {openDrawer === 'latom' && <LatomDrawerContent />}
    </>
  );
}

export default AccountModalDrawerContentsCronos;
